import React from 'react';
import ReactDom from 'react-dom';
import DealerAvailabilitySection from '../react-components/dealer-availability-section';
import CarConnectSection from '../react-components/car-connect-section';
import PostCodeInput from '../react-components/post-code-input';

export default class DealerAvailabilityRenderer {
  constructor(container, data) {
    this._container = container;
    this._data = data;
  }

  render() {
    if (this._data.mode === "dealer-availability") {
      ReactDom.render(<DealerAvailabilitySection
        {...this._data} />,
        this._container);
    }
    else if (this._data.mode === "post-code-input") {
      ReactDom.render(<PostCodeInput
        {...this._data} />,
        this._container);
    }
    else if (this._data.mode === "car-connect") {
      ReactDom.render(<CarConnectSection
        {...this._data} />,
        this._container);
    }
  }

  postcodeChanged = postcode => {
    this._postcode = postcode;
  }
}